import {
  ApolloClient,
} from '@apollo/client';
import {
  GetTravelTimesDocument,
  GetTravelTimesQuery,
  GetTravelTimesQueryResult,
  GetTravelTimesQueryVariables,
  UnavailableDatetime,
} from 'Generated/graphql';
import { AppCookie } from './Cookie';
import { getIsUnavailableAtTime } from 'Common/functions/Availability';

export type TravelTimes =
  NonNullable<
    GetTravelTimesQueryResult['data']
  >['getServiceProviderTravelTimeForAppointment']

const getTravelTimes = async (
  query: ApolloClient<object>['query'],
  sessionJwt: string | undefined,
  serviceProviderUid: string,
  locationUid: string,
  slots: number[],
  duration: number,
) => {
  const res =
    await query<
      GetTravelTimesQuery | null,
      GetTravelTimesQueryVariables
    >({
      query: GetTravelTimesDocument,
      context: sessionJwt ? {
        headers: {
          cookie: `${AppCookie.PeazySession}=${sessionJwt}`,
        }
      } : undefined,
      variables: {
        serviceProviderUid,
        locationUid,
        startDateTimes: slots,
        duration
      },
      fetchPolicy: 'no-cache',
    });

  return res.data?.getServiceProviderTravelTimeForAppointment;
};

export default getTravelTimes;

export const getTimeSlotsFilteredByTravelTime = (
  ts: number[],
  tts: UnavailableDatetime[],
  totalDuration: number,
) => {
  if (tts) {
    const filtered = ts.filter(
      s => {
        const isUnavailable = getIsUnavailableAtTime(
          s,
          s + totalDuration,
          tts.map(t => ({
            min: t.startDateTime,
            max: t.endDateTime,
          })),
        );

        return !isUnavailable;
      },
    );

    return filtered;
  }

  return ts;
};


